import $ from 'jquery'
import { spin } from './_site'
import { createAlert } from './window'
import { getData, validatefields } from './form'
import { handleAxiosErrors, storageAvailable } from '_utils'
import { axiosAuthLogin, axiosAuthForgetPassword, axiosAuthLoginWithOTP } from '../actions/authActions'
import { LS } from '../store/localStorage'

export const timeout = {}
export const send = ($el) => {
  var $submit = $el,
    $form = $submit.closest('.form'),
    $submitAux = $submit.children('span'),
    url = $form.data('action'),
    $modal = $submit.closest('.modal'),
    originData = $modal.length ? $modal.data('login') : {},
    data = $.extend(true, {}, getData($form), originData || {}),
    submitClass = 'form__submit'
  let spinnerTextElem = $('.login-spinner__text')
  let inst = setInterval(change, 50)
  function change() {
    spinnerTextElem.html('<p> Loading your experience <br/> do not refresh your browser</p>')
  }

  function toggleLoader(flag) {
    if (flag) {
      $('.login-spinner__back').addClass('login-spinner__back--show')
      $('.login-spinner__front').addClass('login-spinner__front--show')
    } else {
      $('.login-spinner__back').removeClass('login-spinner__back--show')
      $('.login-spinner__front').removeClass('login-spinner__front--show')
      clearInterval(inst)
    }
  }

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  $submit.addClass('button--disabled')

  console.log(data)

  // validation errors
  if (!validatefields($form, true)) {
    $submit.removeClass('button--disabled')
    return false
  }

  // send data
  toggleLoader(true)

  return axiosAuthLogin({
    email: data.email,
    password: data.password,
  })
    .then(async (response) => {
      if (response?.data?.data?.loginMemberMutation?.Member?.ID) {
        // Flush storage
        localStorage.clear()
        // if (storageAvailable()) localStorage.clear()

        LS.set('triggeredDiscount', false)
        localStorage.setItem('paramountCustomer', JSON.stringify(true))
        const PC = localStorage.getItem('paramountCustomer')
        console.log('PC===================', PC)
        // Close modal (if any)
        $modal.modal('hide')

        // Refresh
        if (response.status === 200) {
          if ($submit.hasClass('lsb--login')) {
            const { ClassName } = response?.data?.data?.loginMemberMutation?.Member
            if (ClassName?.split('\\')?.includes('Supplier')) {
              window.location.href = '/supplier'
            } else if (ClassName?.split('\\')?.includes('Wholesaler')) {
              window.location.href = '/wholesaler'
            }
          } else {
            window.location.reload()
          }
        }
      } else if (response?.data?.data?.loginMemberMutation?.OTPCreated) {
        //Save User Credentials in local storage before sending OTP when login through Admin
        localStorage.setItem('userEmail', JSON.stringify(data.email))
        localStorage.setItem('userPassword', JSON.stringify(data.password))

        // Sent OTP Alert
        createAlert(
          {
            message: 'OTP sent.',
          },
          'success'
        )

        // Hide login form and show OTP form
        let loginElement = document.getElementById('login')
        let otpElement = document.getElementById('verify-otp')
        let customerElement = document.getElementById('become-customer')

        if (loginElement) {
          loginElement.classList?.remove('active')
        }

        if (otpElement) {
          otpElement.classList?.add('active')
        }

        if (customerElement) {
          customerElement.style.display = 'none'
        }
      } else {
        createAlert(
          {
            message: 'Incorrect username or password, please try again.',
          },
          'error'
        )
      }
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
    .then(() => {
      $submit.removeClass('button--disabled')
      toggleLoader(false)
    })
}

export const verifyOtp = ($el) => {
  var $submit = $el,
    $form = $submit.closest('.form'),
    $submitAux = $submit.children('span'),
    url = $form.data('action'),
    $modal = $submit.closest('.modal'),
    originData = $modal.length ? $modal.data('login') : {},
    data = $.extend(true, {}, getData($form), originData || {}),
    submitClass = 'form__submit'
  let spinnerTextElem = $('.login-spinner__text')
  let inst = setInterval(change, 50)
  function change() {
    spinnerTextElem.html('<p> Loading your experience <br/> do not refresh your browser</p>')
  }

  function toggleLoader(flag) {
    if (flag) {
      $('.login-spinner__back').addClass('login-spinner__back--show')
      $('.login-spinner__front').addClass('login-spinner__front--show')
    } else {
      $('.login-spinner__back').removeClass('login-spinner__back--show')
      $('.login-spinner__front').removeClass('login-spinner__front--show')
      clearInterval(inst)
    }
  }

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  $submit.addClass('button--disabled')

  let userEmail = JSON.parse(localStorage.getItem('userEmail') || '')
  let userPassword = JSON.parse(localStorage.getItem('userPassword') || '')

  // validation errors
  if (!validatefields($form, true)) {
    $submit.removeClass('button--disabled')
    return false
  }

  // send data
  toggleLoader(true)

  return axiosAuthLoginWithOTP({
    email: userEmail,
    password: userPassword,
    otp: data.otp,
  })
    .then(async (response) => {
      if (response?.data?.data?.loginMemberMutation?.Member?.ID) {
        // Flush storage
        localStorage.clear()
        // if (storageAvailable()) localStorage.clear()

        LS.set('triggeredDiscount', false)
        localStorage.setItem('paramountCustomer', JSON.stringify(true))
        const PC = localStorage.getItem('paramountCustomer')
        console.log('PC===================', PC)
        // Close modal (if any)
        $modal.modal('hide')

        // Refresh
        if (response.status === 200) {
          window.location.href = '/admin'
        }
      } else {
        createAlert(
          {
            message: 'Incorrect username or password, please try again.',
          },
          'error'
        )
      }
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
    .then(() => {
      $submit.removeClass('button--disabled')
      toggleLoader(false)
    })
}

export const resendOtp = ($el) => {
  var $submit = $el,
    $form = $submit.closest('.form'),
    $submitAux = $submit.children('span'),
    url = $form.data('action'),
    $modal = $submit.closest('.modal'),
    originData = $modal.length ? $modal.data('login') : {},
    data = $.extend(true, {}, getData($form), originData || {}),
    submitClass = 'form__submit'

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  $submit.addClass('button--disabled')

  let userEmail = JSON.parse(localStorage.getItem('userEmail') || '')
  let userPassword = JSON.parse(localStorage.getItem('userPassword') || '')

  // validation errors
  if (!userEmail || !userPassword) {
    $submit.removeClass('button--disabled')
    return false
  }

  return axiosAuthLogin({
    email: userEmail,
    password: userPassword,
  })
    .then(async (response) => {
      if (response?.data?.data?.loginMemberMutation?.OTPCreated) {
        // Resend OTP
        createAlert(
          {
            message: 'OTP sent again.',
          },
          'success'
        )
      } else {
        createAlert(
          {
            message: 'Incorrect username or password, please try again.',
          },
          'error'
        )
      }
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
    .then(() => {
      $submit.removeClass('button--disabled')
    })
}

export const reLogin = ($el) => {
  var $submit = $el,
    $form = $submit.closest('.form'),
    $submitAux = $submit.children('span'),
    url = $form.data('action'),
    $modal = $submit.closest('.modal'),
    originData = $modal.length ? $modal.data('login') : {},
    data = $.extend(true, {}, getData($form), originData || {}),
    submitClass = 'form__submit'

  const loaderHtml = `<span style="visibility:hidden">Apply</span><div class="button__spinner" style="fill: white; height: 25px; width: 25px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"></path>
    <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">
      <animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.8s" repeatCount="indefinite"></animateTransform>
    </path>
  </svg>
  </div>`

  $el.html(loaderHtml)
  // let spinnerTextElem = $('.login-spinner__text')
  // let inst = setInterval(change, 50)

  // function change() {
  //   spinnerTextElem.html('<p> Loading your experience <br/> do not refresh your browser</p>')
  // }

  function toggleLoader(flag) {
    if (flag) {
      $('.login-spinner__back').addClass('login-spinner__back--show')
      $('.login-spinner__front').addClass('login-spinner__front--show')
    } else {
      $('.login-spinner__back').removeClass('login-spinner__back--show')
      $('.login-spinner__front').removeClass('login-spinner__front--show')
      clearInterval(inst)
    }
  }

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  // validation errors
  if (!validatefields($form, true)) {
    return false
  }

  // send data
  toggleLoader(true)

  return axiosAuthLogin({
    email: data.email,
    password: data.password,
  })
    .then(async (response) => {
      $el.html(`<span>Login</span>`)
      if (response?.data?.data?.loginMemberMutation?.Member?.ID) {
        // Flush storage
        localStorage.clear()
        // if (storageAvailable()) localStorage.clear()

        LS.set('triggeredDiscount', false)

        // Close modal (if any)
        $modal.modal('hide')

        // Refresh
        if (response.status === 200) {
          window.location.reload()
        }
      } else {
        $el.html(`<span>Login</span>`)
        createAlert(
          {
            message: 'Incorrect username or password, please try again.',
          },
          'error'
        )
      }
    })
    .catch((error) => {
      handleAxiosErrors(error)
      $el.html(`<span>Login</span>`)
    })
    .then(() => {
      $el.html(`<span>Login</span>`)
      toggleLoader(false)
    })
}

export const sendForgetPassword = ($el) => {
  console.log('$el', { $el })
  var $submit = $el,
    $form = $submit.closest('.form'),
    $modal = $submit.closest('.modal'),
    originData = $modal.length ? $modal.data('login') : {},
    data = $.extend(true, {}, getData($form), originData || {}),
    submitClass = 'form__submit',
    tempVal = $el.html()

  const loaderHtml = `<span style="visibility:hidden">Apply</span><div class="button__spinner" style="fill: white; height: 25px; width: 25px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"></path>
    <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">
      <animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.8s" repeatCount="indefinite"></animateTransform>
    </path>
  </svg>
  </div>`

  $el.html(loaderHtml)

  function toggleLoader(flag) {
    if (flag) {
      $('.login-spinner__back').addClass('login-spinner__back--show')
      $('.login-spinner__front').addClass('login-spinner__front--show')
    } else {
      $('.login-spinner__back').removeClass('login-spinner__back--show')
      $('.login-spinner__front').removeClass('login-spinner__front--show')
    }
  }

  // prevent multiple clicks
  if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
    return false
  }

  console.log(data)

  // validation errors
  if (!validatefields($form, true)) {
    $el.html(tempVal)
    return false
  }

  // send data
  toggleLoader(true)

  function emailMask(email) {
    var [name, domain] = email.split('@')
    var [company, link1, link2] = domain.split('.')
    var newEmail = name + '@' + company
    var maskedEmail = newEmail.replace(/([^@\.])/g, '*').split('')
    var previous = ''
    var i
    for (i = 0; i < maskedEmail.length; i++) {
      if (i < 1 || previous == '.' || previous == '@') {
        maskedEmail[i] = newEmail[i]
      }
      previous = newEmail[i]
    }
    maskedEmail = maskedEmail.join('')
    maskedEmail = maskedEmail + '.' + link1 + '.' + link2
    return maskedEmail
  }

  return axiosAuthForgetPassword({
    email: data.Email || data.email,
    //password: data.password,
  })
    .then((response) => {
      if (response?.data?.data?.resetMemberPassword?.ID) {
        const email = response.data.data.resetMemberPassword.Email
        const maskedEmail = emailMask(email)
        createAlert(
          {
            message: 'A password reset link has been sent to your email address ' + maskedEmail,
          },
          'success'
        )
      } else {
        createAlert(
          {
            message: 'Incorrect email, please try again.',
          },
          'error'
        )
      }
    })
    .catch((error) => {
      handleAxiosErrors(error)
    })
    .then(() => {
      $el.html(tempVal)
      toggleLoader(false)
    })
}

export const binds = () => {
  // ---------------- login
  $('body').on('click', '[data-login]', function (event) {
    event.preventDefault()
    send($(this))
  })

  $('body').on('click', '[data-relogin]', function (event) {
    event.preventDefault()

    reLogin($(this))
  })

  // ---------------- verify otp
  $('body').on('click', '[data-verify-otp]', function (event) {
    event.preventDefault()
    verifyOtp($(this))
  })

  // ---------------- resend otp
  $('body').on('click', '[data-resend-otp]', function (event) {
    event.preventDefault()
    resendOtp($(this))
  })

  // ---------------- forget password
  $('body').on('click', '[data-forget-password]', function (event) {
    event.preventDefault()
    sendForgetPassword($(this))
  })

  $('body').on('click', '[data-reforget-password]', function (event) {
    event.preventDefault()
    sendForgetPassword($(this))
  })
}
